import {useToast} from 'primevue/usetoast'

export function useAppToast() {
  const toast = useToast()

  // 🟢 Success
  const toastSuccess = (detail, summary = 'Successful', life = 500) => {
    toast.add({
      severity: 'success',
      summary,
      detail,
      life
    })
  }

  // 🔴 Error
  const toastError = (detail, summary = 'Failed', life = 1500) => {
    toast.add({
      severity: 'error',
      summary,
      detail,
      life
    })
  }

  // 🟡 Warning
  const toastWarn = (detail, summary = 'Warning', life = 1500) => {
    toast.add({
      severity: 'warn',
      summary,
      detail,
      life
    })
  }

  // 🔵 Info
  const toastInfo = (detail, summary = 'Info', life = 1500) => {
    toast.add({
      severity: 'info',
      summary,
      detail,
      life
    })
  }

  return {
    toastSuccess,
    toastError,
    toastWarn,
    toastInfo
  }
}
